<template>
  <div id="teacher_edu">
    <div class="over_ta">
      <div class="tea_li" style="margin-bottom: 40px;">
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.education}}</div>
        <Table border :columns="backgroundColumn" :data="teacher.background"></Table>
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.course}}</div>
        <div class="tea_tx" v-for="(course,index) in teacher.course" :key="index">{{showCourse(course)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_edu',
  props: ['teacher'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
      backgroundColumn: [
        {
          title: this.showDegreeName(),
          key: 'degree',
          render: (h, params) => {
              return h('div', [
                  h('span', this.showDegree(params.row))
              ]);
          }
        },
        {
          title: this.showSchool(),
          key: 'school_ch'
        },
        {
          title: this.showSchoolEn(),
          key: 'school_en'
        },
        {
          title: this.showGraduationYear(),
          key: 'graduation_year'
        }
      ],
    };
  },
  created() {
  },
  methods: {
    

    showDegree(background) {
      let degreeEn = {'學士': 'Bachelor','碩士': 'Master','博士': 'Doctor'},
          degree = {CH: background.degree, EN: degreeEn[background.degree]};
      return degree[sessionStorage.locale];
    },
    showDegreeName(){
      return ShowPage(sessionStorage.getItem('locale')).degree;
    },
    showSchool(){
      return ShowPage(sessionStorage.getItem('locale')).school;
    },
    showSchoolEn(){
      return ShowPage(sessionStorage.getItem('locale')).school_en;
    },
    showGraduationYear(){
      return ShowPage(sessionStorage.getItem('locale')).graduation_year;
    },
    showCourse(course) {
      let show = {CH: course.course_ch, EN: course.course_en};
      return show[sessionStorage.locale];
    }

  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeacherEdu.vue?0b3b0b59